import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import Cookies from "universal-cookie";
import { sedesPorInstitucionId } from "../../../../Services/Rest";

function CreaSimulacros(props) {
  const cookies = new Cookies();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [list, setList] = useState([]);

  // Estados formulario
  const [postSede, setPostSede] = useState("");
  const [postFecha, setPostFecha] = useState("");
  const [postTipo, setPostTipo] = useState("");
  const [postDuracion, setPostDuracion] = useState("");

  // Cargar sedes
  useEffect(() => {
    axios({
      method: "get",
      url: sedesPorInstitucionId + cookies.get("institucionid"),
    })
      .then((res) => setList(res.data || []))
      .catch((error) => console.log(error));
  }, []);

  const postData = (e) => {
    e.preventDefault();

    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/CreaSimulacros",
      data: {
        sede: postSede,
        fecha_Simulacro: postFecha,
        tipo_Simulacro: postTipo,
        duracion: postDuracion,
        solicitudId: props.idSolicitud,
      },
    })
      .then(() => {
        alert("Simulacro creado con éxito");

        // 🔁 refrescar tabla
        props.onCreate();

        // limpiar formulario
        setPostSede("");
        setPostFecha("");
        setPostTipo("");
        setPostDuracion("");

        setIsOpen(false);
      })
      .catch((error) => {
        console.log(error);
        alert("Error al crear simulacro");
      });
  };

  return (
    <>
      <button className="btn btn-primary mb-3" onClick={() => setIsOpen(true)}>
        Nueva
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={() => setIsOpen(false)}
        ariaHideApp={false}
      >
        <div className="container">
          <div className="card shadow">
            <div className="card-header">
              <h6 className="m-0 font-weight-bold text-primary">
                Crear Simulacro
              </h6>
            </div>

            <div className="card-body">
              <form onSubmit={postData}>
                {/* SEDE */}
                <div className="form-group">
                  <label>Sede</label>
                  <select
                    className="form-control"
                    value={postSede}
                    onChange={(e) => setPostSede(e.target.value)}
                    required
                  >
                    <option value="">Seleccione la sede</option>
                    {list.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.nombre}
                      </option>
                    ))}
                    <option value="0">No tiene</option>
                  </select>
                </div>

                {/* FECHA */}
                <div className="form-group">
                  <label>Fecha del simulacro</label>
                  <input
                    type="date"
                    className="form-control"
                    value={postFecha}
                    onChange={(e) => setPostFecha(e.target.value)}
                    required
                  />
                </div>

                {/* TIPO / DURACIÓN */}
                <div className="form-row">
                  <div className="form-group col-md-6">
                    <label>Tipo de simulacro</label>
                    <input
                      type="text"
                      className="form-control"
                      value={postTipo}
                      onChange={(e) => setPostTipo(e.target.value)}
                      required
                    />
                  </div>

                  <div className="form-group col-md-6">
                    <label>Duración</label>
                    <input
                      type="text"
                      className="form-control"
                      value={postDuracion}
                      onChange={(e) => setPostDuracion(e.target.value)}
                      required
                    />
                  </div>
                </div>

                {/* BOTONES */}
                <div className="text-right mt-4">
                  <button
                    type="button"
                    className="btn btn-secondary mr-2"
                    onClick={() => setIsOpen(false)}
                  >
                    Cancelar
                  </button>

                  <button type="submit" className="btn btn-primary">
                    Guardar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </ReactModal>
    </>
  );
}

export default CreaSimulacros;
